import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useWindowSize from './useWindowSize';
import '../App.css';

export default function Examples({ options, onExampleSelected }) {
    const isMobile = useWindowSize().isMobile;
    const [selectedExample, setSelectedExample] = useState('');

    const examplesContainerStyle = {
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        padding: isMobile ? '1.5rem 1rem' : '2.5rem',
        color: '#fff',
        width: '100%',
        boxSizing: 'border-box',
        position: 'relative',
        backgroundColor: 'rgba(18, 18, 18, 0.55)',
        backdropFilter: 'blur(16px) saturate(120%)',
        boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.5)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        borderRadius: '16px',
        WebkitMaskImage: 'linear-gradient(to bottom, black 80%, transparent 100%)',
        maskImage: 'linear-gradient(to bottom, black 80%, transparent 100%)',
    }

    const pDescriptionStyle = {        
        fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
        padding: '20px',
        backgroundColor: 'rgba(255, 255, 255, 0.05)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        borderRadius: '12px',
        fontWeight: 'normal',
        fontSize: isMobile ? '0.9em' : '1.1em',
        color: '#fff',
        lineHeight: '1.6',
        margin: '0 0 20px 0',
        display: selectedExample ? 'none' : 'block',
    }

    const dropDownStyle = {
        padding: '12px 20px',
        borderRadius: '8px',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        backgroundColor: 'rgba(18, 18, 18, 0.9)',
        color: '#fff',
        width: '100%',
        fontSize: '1.1em',
        textAlign: 'center',
        cursor: 'pointer',
        outline: 'none',
        fontFamily: '"Chivo", sans-serif',
        display: selectedExample ? 'none' : 'block',
    }

    const detailViewStyle = {
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        gap: '25px',
        marginTop: '10px',
        alignItems: 'stretch',
        position: 'relative',
        width: '100%',
    }

    const imgContainerStyle = {
        flex: isMobile ? 'none' : '1.2',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
        borderRadius: '12px',
        overflow: 'hidden',
        padding: '10px',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        boxSizing: 'border-box',
        width: '100%',
    }

    const selectedImgImg = {
        maxWidth: '100%',
        maxHeight: isMobile ? '40vh' : '55vh',
        objectFit: 'contain',
        borderRadius: '8px',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.5)',
    }

    const infoCardStyle = {
        flex: isMobile ? 'none' : '1',
        display: 'flex',
        flexDirection: 'column',
        gap: '15px',
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        borderRadius: '12px',
        color: 'rgb(0, 0, 0)',
        padding: '25px',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
        position: 'relative',
        justifyContent: 'center',
        boxSizing: 'border-box',
        width: '100%',
    }

    const exitExampleStyle = {
        position: 'absolute',
        top: isMobile ? '-10px' : '-15px',
        right: isMobile ? '-10px' : '-15px',
        fontSize: '1.3rem',
        fontWeight: 'bold',
        color: '#fff',
        backgroundColor: 'rgb(242, 66, 12)',
        width: '32px',
        height: '32px',
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
        border: '2px solid #fff',
        zIndex: 10,
    }

    const handleExampleChange = (event) => {
        const newValue = event.target.value;        
        setSelectedExample(newValue);
        if (onExampleSelected) {
            onExampleSelected(newValue);
        }
    };

    const selectedExampleData = options.find(option => option.value === selectedExample);

    const handleRm = () => {
        setSelectedExample('');
    }

    return (
        <div className="Examples" style={examplesContainerStyle}>
            <p style={pDescriptionStyle}>
                Having graduated in the same year as the first public release of an LLM (2023), as a career transitioning millennial 
                with no prior experience in the tech industry, I found it exceedingly difficult to land interviews for IT jobs. After 
                a couple of years of trying with almost no success, I decided to modify my portfolio to reflect more than just the 
                skills I picked up throughout earning my degree. If you are wondering why I am dedicating one of my tabs to home 
                construction projects, the answer is simply that I have learned how to do a lot of different DIY home maintenance 
                and construction projects and consider the skills I have acquired to be assets that convey a general ability to solve problems. 
                I've never worked in construction, and every project I have completed, I did so primarily because I was a student or had 
                a need to save money, having owned 3 different houses since 2016.
            </p>

            <select
                className="dropdown-container"
                style={dropDownStyle}
                id="example-select"
                value={selectedExample}
                onChange={handleExampleChange}
            >
                <option value="" disabled>DIY PROJECTS SELECT</option>
                {options.map((option) => (
                    <option className="dropdown-content" key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>

            {selectedExample && selectedExampleData && (
                <div style={detailViewStyle}>
                    <div style={imgContainerStyle}>
                        {selectedExampleData.imageUrl && (
                            <img
                                className={selectedExample} 
                                style={selectedImgImg}
                                src={selectedExampleData.imageUrl}
                                alt={selectedExampleData.label}                    
                            />
                        )}
                    </div>
                    
                    <div className="description-box" style={infoCardStyle}>
                        <div style={exitExampleStyle} onClick={handleRm}>X</div>
                        <h3 style={{ margin: '0 0 5px 0', fontSize: '1.4em', borderBottom: '2px solid rgb(242, 66, 12)', paddingBottom: '5px' }}>
                            {selectedExampleData.label}
                        </h3>
                        <p style={{ margin: '0', fontSize: '1.1em', lineHeight: '1.5', color: '#333' }}>
                            {selectedExampleData.description}
                        </p>
                        {selectedExampleData.additionalInfo && (
                            <p style={{ margin: '10px 0 0 0', fontSize: '1em', color: '#666', fontStyle: 'italic', borderTop: '1px solid #ddd', paddingTop: '10px' }}>
                                {selectedExampleData.additionalInfo}
                            </p>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}

Examples.propTypes = {
    options: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        imageUrl: PropTypes.string,
        description: PropTypes.string,
        additionalInfo: PropTypes.string,
    })).isRequired,
    onExampleSelected: PropTypes.func
};

Examples.defaultProps = {
    options: [],
    onExampleSelected: null
};
